import { DropDownModel } from "./dropDown";
import { SimpleAddressClass } from "./address";
import { RisksNetworkResponseModel } from "./risksNetwork";
import { SimpleAdditionalInsuranceModel } from "./additionalInsurances";
import { CalculateStore } from "../stores/calculateStore";

export enum OcGuaranteeSum {
    GUARANTEE_SUM_30000 = "GUARANTEE_SUM_30000",
    GUARANTEE_SUM_50000 = "GUARANTEE_SUM_50000",
    GUARANTEE_SUM_100000 = "GUARANTEE_SUM_100000",
    GUARANTEE_SUM_200000 = "GUARANTEE_SUM_200000",
    GUARANTEE_SUM_300000 = "GUARANTEE_SUM_300000",
    GUARANTEE_SUM_500000 = "GUARANTEE_SUM_500000"
}

export interface OcStandardModel extends SimpleAdditionalInsuranceModel {
    ocGuaranteeSum: OcGuaranteeSum;
}

export const DefaultOcStandard: OcStandardModel = {
    checked: false,
    ocGuaranteeSum: OcGuaranteeSum.GUARANTEE_SUM_100000,
    rate: null,
    getRisksNetworkValue: (response: RisksNetworkResponseModel) => response.ocInPrivateLife.standard,
    getValuesFromRetrievedCalculation: (insurance: any, calculateStore: CalculateStore) => {
        calculateStore.additionalInsurances.ocStandard.ocGuaranteeSum = insurance.ocInPrivateLife?.guaranteeSum ?? OcGuaranteeSum.GUARANTEE_SUM_100000;
        calculateStore.additionalInsurances.ocStandard.checked = !!insurance.ocInPrivateLife;
    }
};

export interface OcAdditionalProperty extends SimpleAdditionalInsuranceModel {
    address: SimpleAddressClass;
    validate: () => void;
}

export interface OcResponseModel {
    ocRate: number;
    anotherPropertyRate: number;
    childExtensionRate: number;
    renterExtensionRate: number;
}

export const OcGuaranteeSumDropDown: DropDownModel[] = [
    {
        id: OcGuaranteeSum.GUARANTEE_SUM_30000,
        displayName: "30 000 zł"
    },
    {
        id: OcGuaranteeSum.GUARANTEE_SUM_50000,
        displayName: "50 000 zł"
    },
    {
        id: OcGuaranteeSum.GUARANTEE_SUM_100000,
        displayName: "100 000 zł"
    },
    {
        id: OcGuaranteeSum.GUARANTEE_SUM_200000,
        displayName: "200 000 zł"
    },
    {
        id: OcGuaranteeSum.GUARANTEE_SUM_300000,
        displayName: "300 000 zł"
    },
    {
        id: OcGuaranteeSum.GUARANTEE_SUM_500000,
        displayName: "500 000 zł"
    }
];
